import React from 'react';

const AnimationArrowIconLabel = ({
  label = '',
  icon = null,
}) => {
  return (
    <span className='flex items-center overflow-hidden'>
      {label && (
        <React.Fragment>
          {icon && (
            <span
              aria-hidden={true}
              className={`${icon.classes} transition-opacity opacity-0 group-hover:opacity-100 transform -translate-x-20 transition-transform ease group-hover:translate-x-2`}
              dangerouslySetInnerHTML={{ __html: icon.svg }}
            />
          )}
          <span
            className={`flex items-center ${
              icon.classes.includes(' hidden ')
                ? 'md:transform md:transition-transform md:-translate-x-5 md:group-hover:translate-x-4'
                : 'transform transition-transform -translate-x-5 group-hover:translate-x-4'
            }`}
          >
            <span>{label}</span>
            {icon && (
              <span
                aria-hidden={true}
                className={`${icon.classes} ml-4 transform opacity-transform ease transition-opacity group-hover:opacity-0`}
                dangerouslySetInnerHTML={{ __html: icon.svg }}
              />
            )}
          </span>
        </React.Fragment>
      )}
    </span>
  );
};

export default AnimationArrowIconLabel;
